// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1zzWT","box":"WorkspacesBox_box__-A6aG","node":"WorkspacesBox_node___G-tq"};